import { trimSearch } from '@xmatters/common/utils/searchUtil';
import bluebird from 'utils/bluebird';

export const LOAD_CONFERENCE_BRIDGES = 'LOAD_CONFERENCE_BRIDGES';
export const DELETE_CONFERENCE_BRIDGES = 'DELETE_CONFERENCE_BRIDGES';
export const DELETE_CONFERENCE_BRIDGE = 'DELETE_CONFERENCE_BRIDGE';
export const UPDATE_CONFERENCE_BRIDGE = 'UPDATE_CONFERENCE_BRIDGE';

export const LOAD_CONFERENCE_BRIDGES_FAIL = 'LOAD_CONFERENCE_BRIDGES_FAIL';
export const LOAD_CONFERENCE_BRIDGES_SUCCESS =
  'LOAD_CONFERENCE_BRIDGES_SUCCESS';
export const LOAD_CONFERENCE_BRIDGES_START = 'LOAD_CONFERENCE_BRIDGES_START';

export const UPDATE_CONFERENCE_BRIDGE_FAIL = 'UPDATE_CONFERENCE_BRIDGE_FAIL';
export const UPDATE_CONFERENCE_BRIDGE_SUCCESS =
  'UPDATE_CONFERENCE_BRIDGE_SUCCESS';
export const UPDATE_CONFERENCE_BRIDGE_START = 'UPDATE_CONFERENCE_BRIDGE_START';

export const DELETE_CONFERENCE_BRIDGE_SUCCESS =
  'DELETE_CONFERENCE_BRIDGE_SUCCESS';
export const DELETE_CONFERENCE_BRIDGES_SUCCESS =
  'DELETE_CONFERENCE_BRIDGES_SUCCESS';
export const DELETE_CONFERENCE_BRIDGES_FAIL = 'DELETE_CONFERENCE_BRIDGES_FAIL';
export const DELETE_CONFERENCE_BRIDGES_START =
  'DELETE_CONFERENCE_BRIDGES_START';
export const PROCESSING_CONFERENCE_BRIDGES_ONTO =
  'PROCESSING_CONFERENCE_BRIDGES_ONTO';

export const LOAD_PANEL_ITEM = 'LOAD_PANEL_ITEM';
export const LOAD_PANEL_ITEM_SUCCESS = 'LOAD_PANEL_ITEM_SUCCESS';

export const IS_FORM_DIRTY = 'IS_FORM_DIRTY';

export function setIsFormDirty(isDirty) {
  return {
    type: IS_FORM_DIRTY,
    payload: isDirty,
  };
}

export const setSidePanelItem = data => {
  return {
    type: LOAD_PANEL_ITEM,
    payload: data,
  };
};

export const getSearchFilterParams = props => {
  const { startIndex = 0, stopIndex = 0, search } = props;
  const params = {};
  params.limit = Math.max(100, stopIndex - startIndex);
  params.offset = startIndex;

  const trimmedSearchText = trimSearch(search);
  if (trimmedSearchText.length >= 2) {
    params.search = trimmedSearchText;
    params.operand = 'AND';
  }

  return params;
};

export function getConferenceBridges(props = {}) {
  const params = getSearchFilterParams(props);

  return {
    type: LOAD_CONFERENCE_BRIDGES,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/conference-bridges',
      method: 'get',
      params,
    },
  };
}

export function deleteConferenceBridge(uuid) {
  return {
    type: DELETE_CONFERENCE_BRIDGE,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/conference-bridges/${uuid}`,
      method: 'del',
    },
  };
}

export const deleteConferenceBridges = groupUuids => dispatch => {
  const onSuccess = results => {
    dispatch({ type: DELETE_CONFERENCE_BRIDGES_SUCCESS });
    return results;
  };
  const onFail = error => {
    dispatch({ type: DELETE_CONFERENCE_BRIDGES_FAIL });
    throw error;
  };

  dispatch({ type: PROCESSING_CONFERENCE_BRIDGES_ONTO });
  dispatch({ type: DELETE_CONFERENCE_BRIDGES_START });

  return bluebird
    .mapSeries(groupUuids, uuid => {
      dispatch({ type: PROCESSING_CONFERENCE_BRIDGES_ONTO, payload: uuid });
      return dispatch(deleteConferenceBridge(uuid)).catch(e => ({
        uuid,
        error: e,
      }));
    })
    .then(onSuccess)
    .catch(onFail);
};

export function updateConferenceBridge(params) {
  return {
    type: UPDATE_CONFERENCE_BRIDGE,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/conference-bridges`,
      method: 'post',
      params,
    },
  };
}
